import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Row, Col, Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Calendar from "react-calendar";

import "react-calendar/dist/Calendar.css";
import "./style.scss";
import moment from "moment";
import { useSearchParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faSearch,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { isEmpty } from "lodash";

const propTypes = {
  filter: PropTypes.func,
  setDate: PropTypes.func,
  category: PropTypes.number,
  date: PropTypes.string,
  keyword: PropTypes.string,
  setKeyword: PropTypes.func,
  setSelectedKeyword: PropTypes.func,
  selectedKeyword: PropTypes.array,
  setSelectedCity: PropTypes.func,
  selectedCity: PropTypes.array,
  lang: PropTypes.string,
};

const Filter = ({
  filter,
  category,
  keyword,
  setKeyword,
  setDate,
  date,
  setSelectedKeyword,
  selectedKeyword,
  setSelectedCity,
  selectedCity,
  lang,
}) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const categoryParams = searchParams.get("category");

  const activityKeyword = [
    {
      labelEn: "History/Culture",
      label: "歴史・文化",
    },
    {
      labelEn: "Nature",
      label: "自然",
    },
    {
      labelEn: "Fruit picking",
      label: "フルーツ狩り",
    },
    {
      labelEn: "Leisure",
      label: "レジャー",
    },
    {
      labelEn: "Sports",
      label: "スポーツ",
    },
    {
      labelEn: "Experience/Visit",
      label: "体験・見学",
    },
    {
      labelEn: "Ticket",
      label: "チケット",
    },
  ];

  const okayamaCity = [
    {
      label: "備前エリア",
      labelEn: "Bizen area",
      cities: [
        {
          label: "岡山市",
          labelEn: "Okayama City",
        },
        {
          label: "玉野市",
          labelEn: "Tamano City",
        },
        {
          label: "備前市",
          labelEn: "Bizen City",
        },
        {
          label: "瀬戸内市",
          labelEn: "Setouchi City",
        },
        {
          label: "赤磐市",
          labelEn: "Akaiwa City",
        },
        {
          label: "和気町",
          labelEn: "Wake Town",
        },
        {
          label: "吉備中央町",
          labelEn: "Kibichuo Town",
        },
      ],
    },
    {
      label: "備中エリア",
      labelEn: "Bitchu area",
      cities: [
        {
          label: "倉敷市",
          labelEn: "Kurashiki City",
        },
        {
          label: "笠岡市",
          labelEn: "Kasaoka City",
        },
        {
          label: "井原市",
          labelEn: "Ibara City",
        },
        {
          label: "総社市",
          labelEn: "Soja City",
        },
        {
          label: "高梁市",
          labelEn: "Takahashi City",
        },
        {
          label: "新見市",
          labelEn: "Niimi City",
        },
        {
          label: "浅口市",
          labelEn: "Asakuchi City",
        },
        {
          label: "早島町",
          labelEn: "Hayashima Town",
        },
        {
          label: "里庄町",
          labelEn: "Satosho Town",
        },

        {
          label: "矢掛町",
          labelEn: "Yakage City",
        },
      ],
    },
    {
      label: "美作エリア",
      labelEn: "Mimasaka  area",
      cities: [
        {
          label: "津山市",
          labelEn: "Tsuyama City",
        },
        {
          label: "真庭市",
          labelEn: "Maniwa City",
        },
        {
          label: "美作市",
          labelEn: "Mimasaka City",
        },
        {
          label: "新庄村",
          labelEn: "Shinjo Village",
        },
        {
          label: "鏡野町",
          labelEn: "Kagamino Town",
        },
        {
          label: "勝央町",
          labelEn: "Katsuo Town",
        },
        {
          label: "奈義町",
          labelEn: "Nagi Town",
        },
        {
          label: "西粟倉村",
          labelEn: "Nishiawakura Village",
        },
        {
          label: "久米南町",
          labelEn: "Kumeninami Town",
        },
        {
          label: "美咲町",
          labelEn: "Misaki Town",
        },
      ],
    },
    {
      label: "その他",
      labelEn: "Others",
      cities: [
        {
          label: "その他",
          labelEn: "Others",
        },
      ],
    },
  ];

  const [showCalendar, setShowCalendar] = useState(false);
  const [openKeyword, setOpenKeyword] = useState(false);
  const [openCity, setOpenCity] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  // const [openMap, setOpenMap] = useState(false);

  const resetFilter = () => {
    setDate("");
    // searchParams.delete("category");
    searchParams.delete("date");
    searchParams.delete("keyword");
    if (category) {
      searchParams.set("category", category);
    }
    setSearchParams(searchParams);
    const data = {};
    setSelectedCity();
    setSelectedKeyword([]);
    setCheckboxStates(() => {
      const initialStates = {};
      okayamaCity.forEach((group) => {
        group.cities.forEach((checkbox) => {
          initialStates[
            lang.includes("jp") ? checkbox.label : checkbox.labelEn
          ] = false;
        });
        initialStates[
          lang.includes("jp") ? group.label : group.labelEn
        ] = false;
      });
      return initialStates;
    });
    if (!firstLoad) {
      filter(data);
    }
    setFirstLoad(false);
  };

  const onChange = (date) => {
    setDate(date);
    setShowCalendar(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setOpenKeyword(false);
    setOpenCity(false);
    const dateData = categoryParams === "3" ? false : event.target[0].value;
    const data = {
      date: dateData ? new Date(event.target[0].value) : "",
      category: category,
      keyword: keyword,
      selectedKeyword: selectedKeyword,
      city: selectedCity,
    };
    setShowCalendar(false);
    filter(data);
  };

  const minDate = () => {
    const someDate = new Date();
    const result = someDate.setDate(someDate.getDate() + 0);
    return new Date(result);
  };

  const onSelectSearch = (value, checked) => {
    setSelectedKeyword((prev) =>
      checked ? [...prev, value] : prev.filter((val) => val !== value)
    );
  };
  const [checkboxStates, setCheckboxStates] = useState(() => {
    // Initialize checkbox states based on the provided data
    const initialStates = {};
    okayamaCity.forEach((group) => {
      group.cities.forEach((checkbox) => {
        initialStates[
          lang.includes("jp") ? checkbox.label : checkbox.labelEn
        ] = false;
      });
      initialStates[lang.includes("jp") ? group.label : group.labelEn] = false;
    });
    return initialStates;
  });

  useEffect(() => {
    const cities = searchParams.get("city");
    let selectedCities;
    if (typeof cities === "string") {
      if (cities?.includes(",")) {
        selectedCities = cities?.split(",");
      } else {
        selectedCities = [cities];
      }
    }
    if (!isEmpty(selectedCities)) {
      selectedCities.forEach((selected) => {
        setCheckboxStates((prevStates) => ({
          ...prevStates,
          [selected]: !prevStates[selected],
        }));
      });
    }
  }, []);

  useEffect(() => {
    resetFilter();
  }, [lang]);

  useEffect(() => {
    const cities = Object.keys(checkboxStates).filter(
      (key) => checkboxStates[key]
    );
    setSelectedCity(cities);
  }, [checkboxStates]);

  const handleMasterCheckboxChange = (masterCheckboxId) => {
    const newSelectAll = !checkboxStates[masterCheckboxId];
    setCheckboxStates((prevStates) => {
      const updatedStates = { ...prevStates };
      const group = okayamaCity.find((group) =>
        lang.includes("jp")
          ? group.label === masterCheckboxId
          : group.labelEn === masterCheckboxId
      );

      if (group) {
        group.cities.forEach((checkbox) => {
          updatedStates[
            lang.includes("jp") ? checkbox.label : checkbox.labelEn
          ] = newSelectAll;
        });
      }

      updatedStates[masterCheckboxId] = newSelectAll;
      return updatedStates;
    });
  };

  const handleCheckboxChange = (checkboxId) => {
    setCheckboxStates((prevStates) => {
      const updatedStates = { ...prevStates };
      updatedStates[checkboxId] = !prevStates[checkboxId];

      // Check if all child checkboxes are checked
      const masterCheckboxId = getMasterCheckboxIdForChild(checkboxId);
      const group = okayamaCity.find(
        (group) =>
          (lang.includes("jp") ? group.label : group.labelEn) ===
          masterCheckboxId
      );
      const allChildChecked = group?.cities.every(
        (checkbox) =>
          updatedStates[lang.includes("jp") ? checkbox.label : checkbox.labelEn]
      );

      // Update master checkbox status
      updatedStates[masterCheckboxId] = allChildChecked;

      return updatedStates;
    });
  };

  const getMasterCheckboxIdForChild = (checkboxId) => {
    // Find the group to which the child checkbox belongs
    const group = okayamaCity.find((group) =>
      group.cities.some((checkbox) =>
        lang.includes("jp")
          ? checkbox.label === checkboxId
          : checkbox.labelEn === checkboxId
      )
    );
    // Return the label of the group (master checkbox id)
    return lang.includes("jp") ? group?.label : group?.labelEn;
  };

  return (
    <div className="filterWrapper">
      <div className="container">
        <div className="searchTitle">{t("search_filter")}</div>
        <form onSubmit={handleSubmit} className="mt-3">
          <Row className="position-relative">
            <Col xs={12} className="col-lg mb-3 mb-lg-0">
              <div
                className={`form-select-search ${openKeyword ? "active" : ""}`}
                onClick={() => {
                  setOpenKeyword(!openKeyword);
                  setShowCalendar(false);
                  setOpenCity(false);
                }}
              >
                <span>
                  {!isEmpty(selectedKeyword)
                    ? selectedKeyword?.join(", ")
                    : t("category")}
                </span>
                <div className="icon">
                  <FontAwesomeIcon icon={faChevronDown} />
                </div>
              </div>
            </Col>
            <Col xs={12} className="col-lg mb-3 mb-lg-0">
              <div
                className={`form-select-search city ${
                  openCity ? "active" : ""
                }`}
                onClick={() => {
                  setOpenCity(!openCity);
                  setShowCalendar(false);
                  setOpenKeyword(false);
                }}
              >
                <span>
                  {!isEmpty(selectedCity)
                    ? selectedCity?.join(", ")
                    : t("cities")}
                </span>
                <div className="icon">
                  <FontAwesomeIcon icon={faChevronDown} />
                </div>
              </div>
            </Col>
            {category !== 3 && (
              <Col xs={12} className="col-lg mb-3 mb-lg-0">
                <Form.Control
                  type="input"
                  name="date"
                  placeholder={t("date_placeholder")}
                  readOnly
                  value={date && moment(date).format("YYYY-MM-DD")}
                  onClick={() => {
                    setShowCalendar(!showCalendar);
                    setOpenKeyword(false);
                    setOpenCity(false);
                  }}
                />
                <Calendar
                  minDate={minDate()}
                  onChange={(date) => onChange(date)}
                  value={date}
                  className={!showCalendar ? "hide" : ""}
                />
              </Col>
            )}
            <Col xs={12} className="col-lg mb-3 mb-lg-0 keyword-button">
              <div className="w-100">
                <Form.Control
                  type="text"
                  name="keyword"
                  onClick={() => {
                    setShowCalendar(false);
                    setOpenKeyword(false);
                    setOpenCity(false);
                  }}
                  className="keywordType"
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder={t("enter_keyword")}
                  value={keyword}
                />
              </div>
              <div className="btnWrapper">
                <Button
                  className="searchButton"
                  variant="primary"
                  type="submit"
                >
                  <FontAwesomeIcon icon={faSearch} />
                </Button>
              </div>
            </Col>

            <div className={`keywords search ${openKeyword ? "active" : ""}`}>
              <div className="close" onClick={() => setOpenKeyword(false)}>
                <FontAwesomeIcon icon={faTimes} />
              </div>
              {activityKeyword &&
                activityKeyword.map((key, i) => {
                  return (
                    <Form.Check
                      type="checkbox"
                      label={lang === "jp" ? key?.label : key?.labelEn}
                      key={i}
                      id={lang === "jp" ? key?.label : key?.labelEn}
                      name="nameSearch"
                      checked={selectedKeyword.includes(
                        lang === "jp" ? key?.label : key?.labelEn
                      )}
                      onChange={(event) =>
                        onSelectSearch(
                          lang === "jp" ? key?.label : key?.labelEn,
                          event.target.checked
                        )
                      }
                    />
                  );
                })}
            </div>

            <div className={`keywords ${openCity ? "active" : ""}`}>
              <div className="close" onClick={() => setOpenCity(false)}>
                <FontAwesomeIcon icon={faTimes} />
              </div>
              {okayamaCity &&
                okayamaCity.map((group, i) => {
                  return (
                    <div className="cityFilter" key={i}>
                      <Form.Check
                        type="checkbox"
                        label={lang === "jp" ? group?.label : group?.labelEn}
                        value={lang === "jp" ? group?.label : group?.labelEn}
                        // checked={selectedCity.includes(lang === 'jp' ? group?.label : group?.labelEn)}
                        name="nameSearch"
                        className={`parent ${group?.labelEn}`}
                        checked={
                          checkboxStates[
                            lang === "jp" ? group?.label : group?.labelEn
                          ]
                        }
                        onChange={() =>
                          handleMasterCheckboxChange(
                            lang === "jp" ? group?.label : group?.labelEn
                          )
                        }
                      />
                      <div className="cities">
                        {group?.cities?.map((city, i) => {
                          return (
                            <Form.Check
                              type="checkbox"
                              key={i}
                              id={lang === "jp" ? city?.label : city?.labelEn}
                              label={
                                lang === "jp" ? city?.label : city?.labelEn
                              }
                              value={
                                lang === "jp" ? city?.label : city?.labelEn
                              }
                              // checked={selectedCity?.includes(lang === 'jp' ? city?.label : city?.labelEn)}
                              name={lang === "jp" ? city?.label : city?.labelEn}
                              checked={
                                checkboxStates[
                                  lang === "jp" ? city?.label : city?.labelEn
                                ]
                              }
                              onChange={() =>
                                handleCheckboxChange(
                                  lang === "jp" ? city?.label : city?.labelEn
                                )
                              }
                            />
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
            </div>
          </Row>
          <Button type="button" className="reset" onClick={resetFilter}>
            {t("reset_filter")}
          </Button>
        </form>
      </div>
    </div>
  );
};

Filter.propTypes = propTypes;

export default Filter;
